module.exports = __webpack_public_path__ + "media/images/banner-assets/zh-tw/banner0-b354fb7ea96774fb49f214b5cb3f3a46.jpg";